import script from "./SalesPointsListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesPointsListPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__